import { MarkdownEditor, ViewMode } from '@efdigital/ll-addon-codemirror';
import type { Quiz } from '@efdigital/ll-addon-data';
import { SidebarAll } from '@efdigital/ll-admin-v2/lib/markdown-toolbar';
import Component from '@glimmer/component';

import { EditRecord, type EditRecordSignature } from '../edit-record.gts';

export class EditQuizInput extends Component<EditRecordSignature<Quiz>> {
  setMarkdown = (markdown: string) => {
    this.args.item.markdown = markdown;
  };

  <template>
    <EditRecord
      @editLabel="Edit Input Presentation"
      @item={{@item}}
      @context={{@context}}
      ...attributes
    >
      <:form as |uniqueId isDisabled isReadOnly|>
        {{#if isReadOnly}}
          <h3 class="gud-eyebrow">Input Presentation</h3>
          <p class="form-text">Content displayed to users while they are
            completing the form.</p>

          <textarea
            class="form-control font-monospace form-control-small lh-sm mb-3"
            id="{{uniqueId}}-markdown"
            rows="15"
            readonly
          >{{@item.markdown}}</textarea>
        {{else}}
          <fieldset disabled={{isDisabled}} class="mb-0">
            <legend class="gud-eyebrow">Input Presentation</legend>
            <p class="form-text">Content displayed to users while they are
              completing the form.</p>

            <div class="mb-3">
              <MarkdownEditor
                @markdown={{@item.markdown}}
                @toolbar={{SidebarAll}}
                @mode={{ViewMode.EditorOnly}}
                @onUpdate={{this.setMarkdown}}
              >
                <:preview as |markdown|>
                  <pre>{{markdown}}</pre>
                </:preview>
              </MarkdownEditor>
            </div>
          </fieldset>
        {{/if}}
      </:form>
    </EditRecord>
  </template>
}
